import React from 'react';
import styles from './Footer.module.scss';

function Foooter(props) {
  return (
    <div className={styles.footer}>
      <div className={styles.footerLeftCol}>
        Copyright MSL | 2025
      </div>
    </div>
  );
}

export default Foooter;